var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"dark":"","height":"2500","src":"/imagen_login3.jpg"}})}
var staticRenderFns = []

export { render, staticRenderFns }